import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import * as routes from '../../constants/routes'
import { Client } from 'fulcrum-app'
import { firebase, db } from '../../firebase'
import moment from 'moment';
import { Offline, Online } from "react-detect-offline";

import withAuthorization from '../Session/withAuthorization'
import { Navigation, NavigationSmaller } from '../Navigation'
import Home from '../Home'
import Outline from "../Outline"
import Bores from "../Bores"
import Maintenance from "../Maintenance"
import Prestarts from "../Prestarts"
import Profile from "../Profile"
import Timesheets from "../Timesheets"
import ExplosiveInv from '../ExplosiveInv'
import Calendar from '../Calendar'
import Loader from '../Loader'

import Dev from '../Dev'

import './index.css'
import { Layout, message, Icon, Tooltip, notification } from 'antd'
import 'antd/dist/antd.css' //This is the AntDesign css file

const client = new Client(process.env.REACT_APP_SECRET_KEY)
const listFormIds = [
  { form_id: 'e328b1d1-cd10-46d5-87d8-ace3f02a3344' },
  { form_id: '1390d0f3-7363-470d-847f-7a4f393999d7' },
  { form_id: '5468a3d7-47dd-46d3-bae2-0e9591b5cf26' },
  { form_id: 'dfd98e4f-bfb0-46e9-bb82-7bd0784cbe80' },
  { form_id: '3ebdfb67-0b99-40d2-b937-b91084a12457' },
  { form_id: 'b600af12-d5d0-4b5e-ade0-ef4f500e4171' },
  { form_id: '50038e62-4596-4da6-96e9-5650dc9964b7' },
  { form_id: '3182eaff-898b-43dc-88df-d349913a2d99' },
  { form_id: 'ff9b40a4-61e0-46fb-a592-48a8f90e2d4d' }
]

const { Content, Footer } = Layout

class ClientPortal extends Component {
  constructor() {
    super();
    this.state = {
      user: {
        id: '',
        username: '',
        role: '',
        email: ''
      },
      QualityPlans: [],
      DailyLogs: [],
      Inductions: [],
      Prestarts: [],
      Workshop: [],
      Posts: [],
      Timesheets: [],
      Explosives: [],
      Calendar: [],
      boreList: [],
      loadingScreen: false,
      width: '',
      lastLoaded: <Icon type="loading" />,
      messages: []
    };
  }
  componentDidMount() {

    if (firebase.auth.currentUser) {
      db.getCurrentUsername(firebase.auth.currentUser.uid)
        .then(snapshot => {
          var idFound = snapshot.key
          var usernameFound = snapshot.child("username").val();
          var roleFound = snapshot.child("role").val();
          var emailFound = snapshot.child("email").val();
          this.setState({
            user: {
              id: idFound,
              username: usernameFound,
              role: roleFound,
              email: emailFound
            }
          })
        }
        ).catch(err => message.error('There has been an error loading user data. Please be patient. Error: ' + err, 10))
    }
    if (localStorage.getItem('QualityPlans') !== null &&
      localStorage.getItem('DailyLogs') !== null &&
      localStorage.getItem('Inductions') !== null &&
      localStorage.getItem('Prestarts') !== null &&
      localStorage.getItem('Workshop') !== null &&
      localStorage.getItem('Posts') !== null &&
      localStorage.getItem('Timesheets') !== null &&
      localStorage.getItem('Calendar') !== null) {
      this.setState({
        QualityPlans: JSON.parse(localStorage.getItem('QualityPlans')),
        DailyLogs: JSON.parse(localStorage.getItem('DailyLogs')),
        Inductions: JSON.parse(localStorage.getItem('Inductions')),
        Prestarts: JSON.parse(localStorage.getItem('Prestarts')),
        Workshop: JSON.parse(localStorage.getItem('Workshop')),
        Posts: JSON.parse(localStorage.getItem('Posts')),
        Timesheets: JSON.parse(localStorage.getItem('Timesheets')),
        Calendar: JSON.parse(localStorage.getItem('Calendar')),
      })
      this.loadFulcrumData();
      this.interval = setInterval(() => this.loadFulcrumData(), 600000);

    } else {
      this.setState({ loadingScreen: true })
      this.loadFulcrumData();
      this.interval = setInterval(() => this.loadFulcrumData(), 600000);
    }
    window.addEventListener("resize", this.updateDimensions);
    window.addEventListener("newContentAvailable", () => {
      notification.info({
        message: 'Please refresh the page.',
        description: 'A new version of this site has been released.',
        duration: 0,
        placement: "bottomRight",
        style: {
          borderTop: '2px solid #1a8fff',
          background: '#001529',
          color: '#fff'
        }
      })
    });

  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  }
  componentWillMount() {
    this.updateDimensions()
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  loadFulcrumData(evt) {
    if (evt === 'Button Refresh') { message.loading('Loading Fulcrum data..', 2.5) }
    var promises = listFormIds.map(form_id => client.records.all(form_id));
    Promise.all(promises)
      .then(dataReceived => {

        this.setState({
          QualityPlans: dataReceived[0].objects,
          DailyLogs: dataReceived[1].objects,
          Inductions: dataReceived[2].objects,
          Prestarts: dataReceived[3].objects,
          Workshop: dataReceived[4].objects,
          Posts: dataReceived[5].objects,
          Timesheets: dataReceived[6].objects,
          Explosives: dataReceived[7].objects,
          Calendar: dataReceived[8].objects,
        });

      }).then(() => {
        this.setState({ lastLoaded: moment().format("LT") });
        this.setState({ loadingScreen: false })

        function saveRecentData(data, num) {
          var returned = [];
          data = data.reverse()
          for (let i = 0; i < num; i++) {
            if (data[i] !== undefined) {
              returned.push(data[i])
            }
          }
          return returned
        }

        localStorage.setItem('QualityPlans', JSON.stringify(saveRecentData(this.state.QualityPlans, 10)))
        localStorage.setItem('DailyLogs', JSON.stringify(saveRecentData(this.state.DailyLogs, 100)))
        localStorage.setItem('Inductions', JSON.stringify(saveRecentData(this.state.Inductions, 10)))
        localStorage.setItem('Prestarts', JSON.stringify(saveRecentData(this.state.Prestarts, 100)))
        localStorage.setItem('Workshop', JSON.stringify(saveRecentData(this.state.Workshop, 50)))
        localStorage.setItem('Posts', JSON.stringify(saveRecentData(this.state.Posts, 10)))
        localStorage.setItem('Timesheets', JSON.stringify(saveRecentData(this.state.Timesheets, 100)))
        localStorage.setItem('Calendar', JSON.stringify(saveRecentData(this.state.Calendar, 100)))

        if (evt === 'Button Refresh') { message.success('Data is up to date.') }

        db.lastActive(this.state.user.id, moment().format('Do MMMM YYYY, h:mm:ss a'))

      }).catch((error) => {
        console.log(error)
      });
  }
  printFormat(location) {
    if (window.location.hash.includes('timesheets')) {
      if (location === 'header') {
        return (
          <div className='showThisPrint'>
            <h1>Drilltec Pty Ltd</h1>
          </div>
        )
      }
      if (location === 'footer') {
        return (
          <div className='showThisPrint' style={{marginTop: 20}}>
            <h1 style={{float: 'left'}}>QPpf-7-7</h1>
            <h1 style={{float: 'right'}}>{moment().format('LLLL')}</h1>
          </div>
        )
      }
    }
  }
  render() {
    function navigationBased(width, user) {
      if (width >= 992) { return <Navigation user={user} /> }
      else if (width <= 991) { return <NavigationSmaller user={user} /> }
    }
    var boreListArray = [];
    if (this.state.QualityPlans && this.state.user.username !== null) {
      for (var i = 0; i < this.state.QualityPlans.length; i++) {
        if (this.state.user.role === 'admin') {
          if (this.state.QualityPlans[i].project_id !== null) {
            if (this.state.QualityPlans[i].form_values.b059) {
              var drilltecJobNumber = this.state.QualityPlans[i].form_values.b059;
            } else if (this.state.QualityPlans[i].form_values.c713) {
              drilltecJobNumber = this.state.QualityPlans[i].form_values.c713
            } else {
              drilltecJobNumber = ''
            }
            if (this.state.QualityPlans[i].form_values["72a2"]) {
              var jobsWithin = " | " + this.state.QualityPlans[i].form_values["72a2"]
            } else {
              jobsWithin = ''
            }
            boreListArray.push([drilltecJobNumber, this.state.QualityPlans[i].project_id, jobsWithin]);
          }
        } else if (this.state.user.role === 'client') {
          if (this.state.QualityPlans[i].form_values["6f71"] === this.state.user.username) {
            if (this.state.QualityPlans[i].project_id !== null) {
              if (this.state.QualityPlans[i].form_values.b059) {
                drilltecJobNumber = this.state.QualityPlans[i].form_values.b059;
              } else if (this.state.QualityPlans[i].form_values.c713) {
                drilltecJobNumber = this.state.QualityPlans[i].form_values.c713
              } else {
                drilltecJobNumber = ''
              }
              if (this.state.QualityPlans[i].form_values["72a2"]) {
                jobsWithin = " | " + this.state.QualityPlans[i].form_values["72a2"]
              } else {
                jobsWithin = ''
              }
              boreListArray.push([drilltecJobNumber, this.state.QualityPlans[i].project_id, jobsWithin]);

            }
          }
        }
      }
    }
    function sort_unique(arr) {
      if (arr.length === 0) return arr;
      arr = arr.sort();
      var ret = [arr[0]];
      for (var i = 1; i < arr.length; i++) { //Start loop at 1: arr[0] can never be a duplicate
        if (arr[i - 1][0] !== arr[i][0]) {
          ret.push(arr[i]);
        }
      }
      ret.reverse();
      return ret;
    }
    var boreListValidated = sort_unique(boreListArray);
    if (this.state.loadingScreen === true) {
      return (
        <Layout style={{ minHeight: '100vh' }}>
          <Content style={{ margin: '24px 16px 0', minHeight: '89vh', background: '#f3f3f3' }}>
            <div style={{ padding: 24, background: '#fff', height: '100%' }}>
              <Loader />
            </div>
          </Content>
          <Footer style={{ textAlign: 'center', background: '#f3f3f3' }}>
            Info Sync Solutions ©2018 Created by Jim Alexander
          </Footer>
        </Layout>
      )
    }
    return <Layout>
      {navigationBased(this.state.width, this.state.user)}
      <Layout className="layoutContent">
        <Online>
          <Tooltip title="Data loads automatically after 10 minutes." mouseEnterDelay={2} placement='bottom'>
            <div id="lastLoaded" onClick={() => this.loadFulcrumData("Button Refresh")} className='printHide'>
              <span id='lastLoadedDefault'>Data Last Loaded {this.state.lastLoaded}</span>
              <span id='lastLoadedRefreash'>Click to Refresh Data</span>
            </div>
          </Tooltip>
        </Online>
        <Offline>
          <div id='lastLoaded'>
            <span style={{ color: '#e74c3c', fontWeight: 600 }}>No Internet Connection</span>
          </div>
        </Offline>
        <Content style={{ margin: "24px 16px 0", minHeight: "89vh" }}>
          <div style={{ padding: 24, background: "#fff", height: "100%" }}>
            {this.printFormat('header')}
            <Route exact path={routes.CLIENTPORTAL} render={props => <Home {...props} user={this.state.user} posts={this.state.Posts} QualityPlans={this.state.QualityPlans} DailyLogs={this.state.DailyLogs} prestarts={this.state.Prestarts} />} />
            <Route path={routes.OUTLINE} render={props => <Outline {...props} QualityPlans={this.state.QualityPlans} user={this.state.user} />} />
            <Route path={routes.BORES} render={props => <Bores {...props} user={this.state.user} QualityPlans={this.state.QualityPlans} DailyLogs={this.state.DailyLogs} boreList={boreListValidated} />} />
            <Route path={routes.CALENDAR} render={props => <Calendar {...props} user={this.state.user} events={this.state.Calendar} QualityPlans={this.state.QualityPlans} />} />
            <Route path={routes.MAINTENANCE} render={props => <Maintenance {...props} workshop={this.state.Workshop} />} />
            <Route path={routes.PRESTARTS} render={props => <Prestarts {...props} prestarts={this.state.Prestarts} />} />
            <Route path={routes.TIMESHEETS} render={props => <Timesheets {...props} user={this.state.user} timesheets={this.state.Timesheets} />} />
            <Route path={routes.PROFILE} render={props => <Profile {...props} user={this.state.user} />} />
            <Route path={routes.EXPLOSIVEINV} render={props => <ExplosiveInv {...props} user={this.state.user} explosives={this.state.Explosives} />} />
            <Route path={routes.DEVELOPER} render={props => <Dev {...props} user={this.state.user} QualityPlans={this.state.QualityPlans} />} />
            {this.printFormat('footer')}
          </div>
        </Content>
        <Footer style={{ textAlign: "center", background: '#f3f3f3' }} className='printHide'>
          Info Sync Solutions ©2018 Created by Jim Alexander
          </Footer>
      </Layout>
    </Layout>;
  }
}
const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(ClientPortal);
